<div class="toggle-field">
    <div class="title">
        <p>{{ label | locale }}</p>
    </div>

    <div class="slide-toggle">
        <mat-slide-toggle
            color="primary"
            hideIcon
            [checked]="value"
            (change)="onChangeEvent.emit($event)"
            (click)="onClickEvent.emit($event)">
        </mat-slide-toggle>
    </div>
</div>
